import React, { FunctionComponent } from 'react';
import { SkeletonRow, Rectangular } from '@Components/Skeleton/Skeleton.styled';

interface IDeliveryAddressSekeleton {
	simplifiedCheckout: boolean;
}

const DeliveryAddressSekeleton: FunctionComponent<IDeliveryAddressSekeleton> = ({ simplifiedCheckout }) => {
	return (
		<>
			{!simplifiedCheckout && (
				<SkeletonRow marginTop={8} marginRight={16}>
					<Rectangular width="100%" height={390} marginBottom={16} />
				</SkeletonRow>
			)}
			<SkeletonRow
				marginTop={8}
				{...(simplifiedCheckout ? { style: { width: '80%', margin: 'auto', justifyContent: 'center' } } : {})}
			>
				<Rectangular width="100%" height={48} marginBottom={20} />
				<Rectangular width="100%" height={48} marginBottom={20} />
				<Rectangular width="100%" height={48} marginBottom={20} />
				<Rectangular width="100%" height={48} marginBottom={20} />
				{!simplifiedCheckout && <Rectangular width="100%" height={48} marginBottom={20} />}
			</SkeletonRow>
		</>
	);
};

export default DeliveryAddressSekeleton;
